var $d1341bbc3e1d2378$exports = {};
$d1341bbc3e1d2378$exports = {
    "collapse": `Reduzieren`,
    "columnResizer": `Spaltenanpassung`,
    "drag": `Ziehen`,
    "expand": `Erweitern`,
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`,
    "resizeColumn": `Spaltengr\xf6\xdfe \xe4ndern`,
    "sortAscending": `Aufsteigend sortieren`,
    "sortDescending": `Absteigend sortieren`
};


export {$d1341bbc3e1d2378$exports as default};
//# sourceMappingURL=de-DE.module.js.map
